export const openGladlyChat = () => {
  if (window.Gladly) {
    window.Gladly.show();
  }
};
